<template>
	<div class="main" style="width:1440px;margin: 0 auto; ">
		<div class="banner_box">
			<img src="/banner02.jpg" alt="" width="1440px" height="300px">
		</div>
		<div class="container">
			<template v-for="(item,index) in productServiceList">
				<div class="box">
					<!-- <img v-if="item.img" :src="imgurl+item.img" alt="" srcset="" width="50" height="50">
					<div v-if="!item.img" style="height: 50;"></div> -->
					<div>{{item.name}}</div>
					<!-- <div>{{item.description}}</div> -->
					<div><p v-html="item.description"></p></div>
					
					
				</div>
			</template>
		</div>
		<div class="img_show" style="padding-top: 50px;padding-bottom: 100px; background-color: #F2F2F2;">
			<div style="font-size: 28px;color: #101010;text-align: center;">服务优势</div>
			<div class="youshi">
				<template v-for="(item,index) in serviceAdvList">
					<div>
						<div class="icon_box">
							<img src="/star.png" alt="" height="50" width="50">
						</div>
						<span>{{item.title}}</span>
					</div>
				</template>
			</div>
		</div>
		
		<div class="img_show" style="padding-top: 50px;padding-bottom: 100px; background-color: #fff;">
			<div style="font-size: 28px;color: #101010;text-align: center;">适用行业</div>
			<div class="hangye">
				<template v-for="(item,index) in industryList">
					<div>
						<img :src="imgurl+item.img" alt="" width="150" height="150" class="icon_box">
						<span>{{item.title}}</span>
					</div>
				</template>
			</div>
		</div>

	</div>
</template>

<script>
	
	import Vue from 'vue';
	import {
		imgurl,getAction,putformAction
	} from "@/api/manage";
		
		
	export default {
		name: 'HelloWorld2',
		props: {
			msg: String
		},
		data() {
			return {
				imgurl: imgurl,
				productServiceList:[],
				serviceAdvList:[],
				industryList:[],
			}
		},
		mounted(e) {
			this.getProductService()
			this.getServiceAdvList()
			this.getIndustryList()
		},
		watch: {
			$route: {
				deep: true,
				immediate: true,
				handler(val) {
					this.updatetype();
				}
			}
		},
		
		
		methods: {
			getProductService(){
				let that = this;
				let param = {};
				getAction("viwo/productServices/getList", param).then(res => {
					if (res.success && res.result) {
						that.productServiceList = res.result;
						console.log("公司信息res===",res)
					}
				})
			},
			
			getServiceAdvList() {
				let that = this;
				let param = {
					type:'服务优势'
				};
				getAction("viwo/aboutUs/getList", param).then(res => {
					if (res.success && res.result) {
						that.serviceAdvList = res.result.records;
						console.log("公司信息res===",res)
					}
				})
			},
			getIndustryList() {
				let that = this;
				let param = {
					type:'适用行业'
				};
				getAction("viwo/aboutUs/getList", param).then(res => {
					if (res.success && res.result) {
						that.industryList = res.result.records;
						console.log("公司信息res===",res)
					}
				})
			}
			

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.main {
		width:1440px;
		margin: 0 auto; 
		// min-height: 1426px;
	}
	a {
		// text-decoration: none;
	}
	
	.container {
		width: 1200px;
		margin: 110px auto;
		display: flex;
		justify-content: space-between;
		.box {
			width: 359px;
			height: 450px;
			line-height: 20px;
			background-color: rgba(255,255,255,1);
			color: rgba(16,16,16,1);
			font-size: 14px;
			text-align: center;
			font-family: -regular;
			border: 1px solid rgba(174,174,174,1);
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			// margin: 30px;
			div:nth-child(1){
				// width: 168px;
				height: 36px;
				line-height: 36px;
				color: rgba(56,148,255,1);
				font-size: 24px;
				text-align: left;
				font-family: SourceHanSansSC-regular;
				margin:20px 0 47px;
			}
			div:last-child{
				width: 80%;
				height: 280px;
				line-height: 27px;
				color: rgb(174,174,174);
				font-size: 18px;
				text-align: center;
				font-family: SourceHanSansSC-regular;
				overflow: hidden;	
				padding-left: 60px;
				ul{
					margin-left: 20px;
				}
			}
		}
		// .box:last-child {
		// 	div:last-child{
		// 		padding-left: 60px;
		// 	}
		// }
	}
	
	.youshi {
		margin: 55px auto;
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		gap:120px;
		justify-content: space-between;
		
		div {
			
			flex: 0 0 calc(20% - 120px); 
			box-sizing: border-box;
			height: 120px;
		}
		span  {
			display: block;
			text-align: center;
			font-size: 18px;
			margin-top: 15px;
		}
		.icon_box {
			width: 120px;
			height: 120px;
			background-color: #fff;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			
		}
	}
	.hangye {
		margin: 55px auto;
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		gap:100px;
		justify-content: space-between;
		
		div {
			
			flex: 0 0 calc(20% - 100px); 
			box-sizing: border-box;
			height: 150px;
		}
		span  {
			display: block;
			text-align: center;
			font-size: 18px;
			margin-top: 15px;
		}
		.icon_box {
			width: 150px;
			height: 150px;
			background-color: #fff;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			
		}
	}
</style>